import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { cn } from "@/lib/utils";
import TutorSheet from "./TutorSheet";

// Routes where the tutor FAB should NOT render. Admin pages have their own
// dense layouts and the tutor isn't useful there. Shared/public artifact
// pages (read-only) are skipped to keep them clean for screenshots/embeds.
const HIDDEN_PREFIXES = ["/admin", "/cert/"];

export default function AskTutorFAB() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close the sheet automatically on route change so it never lingers
  // over an unrelated page.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Allow the unified menu to pop the tutor sheet open without rendering
  // the floating FAB.
  useEffect(() => {
    const fn = () => setOpen(true);
    window.addEventListener("open-tutor", fn);
    return () => window.removeEventListener("open-tutor", fn);
  }, []);

  const hidden = HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));
  if (hidden) return null;

  return (
    <>
      <TutorSheet open={open} onOpenChange={setOpen} />
    </>
  );
}